const slideshowEl = document.querySelector(".swiper-slideshow");

const slideshowOptions = {
  // Optional parameters
  loop: true,
  slidesPerView: 1,
  slidesPerGroup: 1,
  grabCursor: true,
};

if (slideshowEl && slideshowEl.dataset.autoplay === "true") {
  slideshowOptions.autoplay = {
    delay: (Number(slideshowEl.dataset.delay) || 5) * 1000,
  };
}

const swiperSlideshow = new Swiper(".swiper-slideshow", slideshowOptions);
